//var videoId = '-pOrRaXdqlM';
var videoId = $('.video-container').attr('data-video-id');
var videoScriptLoaded = false;
var player;
var width = "100%";
var height = "320px";

// LOAD VIDEO SCRIPT
function loadVideoScript(new_video_id) {
	// 2. This code loads the IFrame Player API code asynchronously.
	var tag = document.createElement('script');
	tag.src = "https://www.youtube.com/iframe_api";
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	setDimensions();
	if (new_video_id) {
		videoId = new_video_id;
	}
	videoScriptLoaded = true;
}

// SET PLAYER DIMENSIONS
var setDimensions = function() {
	if (window.innerWidth >= 768) {
		width = '640';
		height = '390';
	}
	$('#player').width(width);
	$('#player').height(height);
};

$(window).resize(function(){
	if (window.innerWidth <= 767) {
		$('.navigation-menu').prepend($('.social-media'));
	}
	if (window.innerWidth >= 768) {
		$('.locale_switcher').append($('.social-media'))
	}
});

$(document).ready(function() {

	function hideModal() {
		$('.modal-content').addClass('hidden');
	}

	function modalNone(){
		$('.modal-content').removeClass('hidden');
		$('.modal-content').addClass('displayNone');
	}

	setTimeout(hideModal, 10000);
	setTimeout(modalNone, 10500);

});

// 3. This function creates an <iframe> (and YouTube player) after the API code downloads.
function onYouTubeIframeAPIReady() {
	player = new YT.Player('player', {
		width: width,
		height: height,
		videoId: videoId,
		events: {
			'onReady': onPlayerReady,
			'onStateChange': onPlayerStateChange
		}
	});
}

// 4. The API will call this function when the video player is ready.
function onPlayerReady(event) {
	//event.target.playVideo();
}

// 5. The API calls this function when the player's state changes. The function indicates that when playing a video (state=1), the player should play for six seconds and then stop.
var done = false;

function onPlayerStateChange(event) {
	// if (event.data == YT.PlayerState.PLAYING && !done) {
	//   setTimeout(stopVideo, 6000);
	//   done = true;
	// }
}

function stopVideo() {
	player.stopVideo();
}

$(window).resize(function() {

	var more = document.getElementById("js-navigation-more");
	if ($(more).length > 0) {
		var windowWidth = $(window).width();
		var moreLeftSideToPageLeftSide = $(more).offset().left;
		var moreLeftSideToPageRightSide = windowWidth - moreLeftSideToPageLeftSide;
		if (moreLeftSideToPageRightSide < 330) {
			$("#js-navigation-more .submenu .submenu").removeClass("fly-out-right");
			$("#js-navigation-more .submenu .submenu").addClass("fly-out-left");
		}
		if (moreLeftSideToPageRightSide > 330) {
			$("#js-navigation-more .submenu .submenu").removeClass("fly-out-left");
			$("#js-navigation-more .submenu .submenu").addClass("fly-out-right");
		}
	}

	if (videoScriptLoaded) {
		setDimensions();
	}

});



/**
 * Trigget a select box to open
 * --
 * @param  {[type]} function($ [description]
 * @return {[type]}            [description]
 */
(function($) {
	"use strict";
	$.fn.openSelect = function() {
		return this.each(function(idx, domEl) {
			if (document.createEvent) {
				console.log('... create event ...')
				var event = document.createEvent("MouseEvents");
				event.initMouseEvent("mousedown", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
				domEl.dispatchEvent(event);

				console.log(domEl)

			} else if (element.fireEvent) {
				domEl.fireEvent("onmousedown");
			}
		});
	}
}(jQuery));

// DOC READY
$(function() {

	// BURGER MENU - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

	$("#js-navigation-menu").removeClass("show");

	$("#js-mobile-menu").off().on("click", function(e) {
		e.preventDefault();
		$("#js-navigation-menu").slideToggle(function() {

			if ($("#js-navigation-menu").is(":hidden")) {
				$("#js-navigation-menu").removeAttr("style").removeClass('open');
			} else {
				$("#js-navigation-menu").addClass('open');
			}

		});
	});

	// LIGHTBOX - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

	var lightbox_close = function() {
		$('.lightbox-target').removeClass('lightbox-open');
		$('.lightbox-target').removeClass('lightbox-open-news');

		$('body').removeClass('noScroll');
		if ($('.lightbox-target').attr('id') !== 'news_signup') {
			stopVideo();
		}
	};
	var lightbox_open = function($target) {
		$target.toggleClass('lightbox-open');
		$('body').toggleClass('noScroll');
	};
	$('.lightbox-toggle').on('click', function(e) {
		e.preventDefault();
		var $new_video_id = $(this).data('video');
		if (!videoScriptLoaded) {
			loadVideoScript($new_video_id);
		}
		lightbox_open($($(this).attr('href')));
	});

	$('.lightbox-close').on('click', function(e) {

		console.log('there was a cloise')


		e.preventDefault();
		lightbox_close();
	});

	$('.lightbox-target').on('click', function(e) {
		if (e.target !== e.currentTarget) {
			return;
		}
		e.preventDefault();
		lightbox_close();
	});

	// PRODUCT TABS - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//
	if ($('.products-tabs').length > 0) {
		$('.products-tabs').each(function(index) {
			$(this).children('li').first().children('a').addClass('is-active').next().addClass('is-open').show();
		});
		$('.products-tabs').on('click', 'li > a.tab-link', function(event) {
			if (!$(this).hasClass('is-active')) {
				event.preventDefault();
				var accordionTabs = $(this).closest('.products-tabs');
				accordionTabs.find('.is-open').removeClass('is-open').hide();
				$(this).next().toggleClass('is-open').toggle();
				accordionTabs.find('.is-active').removeClass('is-active');
				$(this).addClass('is-active');
			} else {
				event.preventDefault();
			}
		});
	}

	/**
	 * Language select / drop down
	 * --
	 * @type {[type]}
	 */
	$(".dropdown-button").click(function() {
		var $button, $menu;
		$button = $(this);
		$menu = $button.siblings(".dropdown-menu");
		$menu.toggleClass("show-menu");
		$menu.children("li").click(function() {
			$menu.removeClass("show-menu");
			$button.html($(this).html());
		});
	});

	//on the news pages flip the right to the left
	//
	if ($('body').hasClass('news')) {
		if ($('body').hasClass('desktop') || $('body').hasClass('tablet')) {
			if (window.innerWidth >= 768) {
				$('.block-right').insertBefore(".block-left").addClass('news-left-sidebar');
			}
		}
	}

	$(window).resize(function() {
		if ($('body').hasClass('news')) {
			if ($('body').hasClass('desktop') || $('body').hasClass('tablet')) {
				if (window.innerWidth >= 768) {
					$('.block-right').insertBefore(".block-left").addClass('news-left-sidebar');
				}
			}
		}
	});

	//sticky header scroll functions
	//
	$(window).scroll(function() {
		if ($(this).scrollTop() > 75) {
			$('body').addClass("sticky");
		} else {
			$('body').removeClass("sticky");
		}
	});

	// Fade in elements
	//
	var element = '.js-fadeInElement';
	$(element).addClass('js-fade-element-hide');

	//how or hide element
	//
	var show_func = function(_this) {
		var elementTopToPageTop = $(_this).offset().top;
		var windowTopToPageTop = $(window).scrollTop();
		var windowInnerHeight = window.innerHeight;
		var elementTopToWindowTop = elementTopToPageTop - windowTopToPageTop;
		var elementTopToWindowBottom = windowInnerHeight - elementTopToWindowTop;
		var distanceFromBottomToAppear = 150;

		if (elementTopToWindowBottom > distanceFromBottomToAppear) {
			$(_this).addClass('js-fade-element-show');
		} else if (elementTopToWindowBottom < 0) {
			$(_this).removeClass('js-fade-element-show');
			$(_this).addClass('js-fade-element-hide');
		}
	}

	//window scroll
	//
	$(window).scroll(function() {
		var element = '.js-fadeInElement';
		$(element).each(function(i, v) {
			var _this = this
			show_func(_this);
		})
	});
	$(window).trigger('scroll');

	//news subscription
	//
	$('.subscribe-btn').click(function(e) {
		e.preventDefault();
		console.log('---> subscribe');
	});

	var news_lightbox_close = function() {
		$('.lightbox-target').removeClass('lightbox-open-news');
		$('body').removeClass('noScroll');
	};

	var news_lightbox_open = function($target) {
		$('.this-is-a-message').text('');
		$('#news-subForm input').val('');
		$target.toggleClass('lightbox-open-news');
		$('body').toggleClass('noScroll');
	};

	$('.news-lightbox-toggle').on('click', function(e) {
		e.preventDefault();
		news_lightbox_open($($(this).attr('href')));
	});

	$('.news-lightbox-close, .lightbox-open-news').on('click', function(e) {
		e.preventDefault();
		news_lightbox_close();
	});


	// http://stackoverflow.com/questions/19999388/check-if-user-is-using-ie-with-jquery
	function isIE() {

		var ua = window.navigator.userAgent;
		var msie = ua.indexOf("MSIE ");
		if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
			return true
		}
		return false;
	}

	if ($('#news-subForm').length) {
		if (isIE()) {
			//replace the https for http when ie as we are usign the CP monitor url.
			//pretty much an IE 10 bug
			var act = $('#news-subForm').attr('action');
			act = act.replace('https://', 'http://');
			$('#news-subForm').attr('action', act)
		}
	}

	$('#news-subForm').submit(function(e) {
		//console.log('---> there was a submission')
		var form_data = $(this).serialize();
		var form_url = $(this).attr('action');
		$('.this-is-a-message').text('');
		//console.log('we are here',  form_url + "&callback=?");
		if (isIE()) {
			//console.log('the browser is IE');
		} else {
			// https://gist.github.com/jdennes/1155479
			e.preventDefault();
			$.getJSON(
				form_url + "?callback=?",
				form_data,
				function(data) {
					//console.log('function data', data);
					if (data.Status === 400) {
						console.log("Error: " + data.Message);
						$('#news-subForm input').val('');
						$('.this-is-a-message').text('Oops, we could not do that. Are you already subscribed?');
					} else { // 200
						console.log("Success: " + data.Message);
						$('#news-subForm input').val('');
						$('.this-is-a-message').text('Thank you, you have been added to the subscription list.')
					}
				});
		}
	});
	// Locale modal

	function setCookie(cname, cvalue, exdays) {
		var d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		var expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	var $localeModal = $('.modal.locale-modal');
	if ($localeModal.length && document.cookie.indexOf('locale-modal') == -1) {
		var $localeModalTrigger = $localeModal.find('#modal-1');
		$localeModalTrigger.prop('checked', true);
		$localeModal.find('.dismiss, .modal-close').on('click', function() {
			$localeModalTrigger.prop('checked', false);
			setCookie('locale-modal', 1, 60);
		});
		$localeModal.find('.follow').on('click', function() {
			var userLocale = $(this).data('locale');
			if (userLocale != undefined) {
				setCookie('locale-modal', 1, 60);
				var $localisedLink = $('link[hreflang="' + userLocale + '"]');
				if ($localisedLink.length) {
					window.location.href = $localisedLink.attr('href');
				} else {
					// We don't have a segment for english / us
					if (userLocale == 'en-us') {
						userLocale = '';
					}
					window.location.href = '/' + userLocale;
				}
			} else {
				$localeModalTrigger.prop('checked', false);
			}
		});

	}

});

$("#modalCloseBtn").click(function() {
	$("#ambassadorModal").fadeOut(500);
});
